import { render, staticRenderFns } from "./EditCourseCharge.vue?vue&type=template&id=131003c4&scoped=true&"
import script from "./EditCourseCharge.vue?vue&type=script&lang=js&"
export * from "./EditCourseCharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131003c4",
  null
  
)

export default component.exports